import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './assets/fonts/fonts.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Vehicle from './components/Vehicle';
// Tarifs component removed as requested
import Contact from './components/Contact';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#9e1c20', // Rouge du logo
      light: '#c14348',
      dark: '#6b0000',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#333333', // Gris foncé pour compléter
      light: '#5c5c5c',
      dark: '#0c0c0c',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f0e5', // Beige élégant comme fond par défaut
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Quicksand", sans-serif',
    h1: {
      fontWeight: 600,
      fontFamily: '"Satisfy", cursive',
      letterSpacing: '0.5px',
      fontSize: '2.8rem',
    },
    h2: {
      fontWeight: 500,
      fontFamily: '"Satisfy", cursive',
      letterSpacing: '0.3px',
      fontSize: '2.2rem',
    },
    h6: {
      fontFamily: '"Satisfy", cursive',
      fontWeight: 400,
      letterSpacing: '0.2px',
      fontSize: '1.4rem',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="app">
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Services />
                <Vehicle />
                <Contact />
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
